module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxMCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik04LjI2MDIgOC4yOTk4TDQuNjggMTEuNTEzOEwxLjA5OTggOC4yOTk4TDAgOS4yODkyOEw0LjY4IDEzLjQ5OThMOS4zNiA5LjI4OTI4TDguMjYwMiA4LjI5OThaIiBmaWxsPSIjOTU5NTk1Ii8+DQo8cGF0aCBkPSJNMS4wOTkxNyA1LjcwMDE5TDQuNjc5MzggMi40ODYxNkw4LjI1OTU4IDUuNzAwMkw5LjM1OTM4IDQuNzEwNzJMNC42NzkzOCAwLjUwMDE5NkwtMC4wMDA2MjU1MTMgNC43MTA3MkwxLjA5OTE3IDUuNzAwMTlaIiBmaWxsPSIjOTU5NTk1Ii8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homebase/bookmarks/sorting-caret.svg
// module id = UJ1S
// module chunks = 1